export default "__VITE_PUBLIC_ASSET__4bca2f2c__"